import { FC, useEffect, useRef, useState } from "react"
import { useDataTableStore } from "../../stores/DataTableStore"
import { useSettingsStore } from "../../stores/SettingsStore"
import { KTSVG } from "../../_metronic/helpers"
import * as ExcelJS from 'exceljs';
import { FileUploader } from "react-drag-drop-files";
import { useFormik } from "formik"
import useUser from "../../hooks/User"
import Swal from "sweetalert2"
import { DataTableExportTemplate } from "./DataTableExportTemplate"
import useAccessToken from "../../hooks/AccessToken"
import { getAttendanceTemplates, getCities, getLeaders, getRoles } from "../../api/General"
import { getUsers, updateUser } from "../../api/UsersCRUD"
import { Dropdown } from "rsuite"
import { CustomField } from "../../interfaces/Settings"
import moment from "moment";
import { customThousandSeparatorDot, isEmail, normalizeDate, randomColor } from "../../functions/general"
import { useIntl } from "react-intl"
import { mutate } from "swr"
import { getUnit, insertUnit, updateUnit } from "../../api/UnitsCRUD"
import { getLabel } from "../../api/LabelsCRUD"
import { usePipelineStore } from "../../stores/PipelineStore"
import { useParams } from "react-router-dom"
import { useMerchantStore } from "../../stores/MerchantStore"
import useHandleImportPipeline from "./HandleImport/useHandleImportPipeline"
import useHandleImportMerchant from "./HandleImport/useHandleImportMerchant"
import useHandleImportProduct from "./HandleImport/useHandleImportProduct"
import { useMeetingStore } from "../../stores/MeetingsStore"
import { useUserStore } from "../../stores/UserStore"
import { getCustomFieldError, getCustomFieldFilteredMerchant, getCustomFieldFilteredPipeline, getCustomFieldFilteredUser, getCustomFieldsValues, validateLabel, validationListLeadTemplateAccess } from "../../functions/ExportTemplateExcel/functionHelperExcel"
import useHandleImportUser from "./HandleImport/useHandleImportUser"
import { useGeneralStore } from "../../stores/General"
import ModalSelectDataCustomField from "./ModalSelectDataCustomField"
import { useCurrencyStore } from "../../stores/CurrencyStore"
import { useProductStore } from "../../stores/ProductStore"
import { AccessLeadTemplate } from "../../interfaces/AccessLeadTemplate";
import { getLeadTemplateSetting } from "../../api/LeadTemplateSetting";
import { getAccessProductPipeline } from "../../api/ProductsCRUD";
import { getPriceVariant } from "../../api/PriceVariantCRUD";

interface DataTableImportProps {
  source: 'template-merchant' | 'template-user' | 'template-pipeline' | 'template-unit' | 'template-product',
  displayMode?: string
  masterLabels?: any[]
}

const API_URL = process.env.REACT_APP_API_URL

const DataTableImport: FC<DataTableImportProps> = ({ source, displayMode, masterLabels }) => {
  const { tablesData, setTablesData, setFetchCounter, fetchCounter } = useDataTableStore()
  const { multiPipelines, selectMultiPipeline, simplePipelines } = usePipelineStore()
  const { multiMerchants, selectMultiMerchant, simpleMerchants } = useMerchantStore()
  const { simpleMeetings } = useMeetingStore()
  const { simpleProducts } = useProductStore()
  const { multiCurrencies } = useCurrencyStore()
  const { settings } = useSettingsStore()
  const { templatePipelineId, templateMerchantId } = useParams()
  const user = useUser()
  const { users } = useUserStore()
  const modalRef = useRef<HTMLDivElement | null>(null)
  const closeModalRef = useRef<HTMLButtonElement>(null)
  const token = useAccessToken()
  const [indexUpload, setIndexUpload] = useState(0)
  const [listData, setListData] = useState<any>([])
  const [listDataProduct, setListDataProduct] = useState<any>([])
  const [dataUsers, setDataUsers] = useState([])
  const [dataCities, setDataCities] = useState([])
  const [dataRoles, setDataRoles] = useState([])
  const [dataLeaders, setDataLeaders] = useState([])
  const [dataAttendanceTemplates, setDataAttendanceTemplates] = useState([])
  const [dataLabels, setDataLabels] = useState([])
  const [dataUnits, setDataUnits] = useState([])
  const [dataPriceVariants, setDataPriceVariants] = useState([])
  const [isLoadingLabel, setIsLoadingLabel] = useState<boolean>(false)
  const [isLoadingUnit, setIsLoadingUnit] = useState<boolean>(false)
  const [isLoadingPriceVariant, setIsLoadingPriceVariant] = useState<boolean>(false)
  const [customFields, setCustomFields] = useState<CustomField>({})
  const [listErrorInsert, setListErrorInsert] = useState<any>([])
  const [listErrorInsertProduct, setListErrorInsertProduct] = useState<any>([])
  const [listErrorUpdate, setListErrorUpdate] = useState<any>([])
  const [typeAction, setTypeAction] = useState<"insert" | "update">("insert")
  const { isOpenModalSelectCustomField, setIsOpenModalSelectCustomField, setIsCustomFieldPipeline, setIsCustomFieldMerchant, setIsCustomFieldUser, setIsCustomFieldMeeting } = useGeneralStore();
  const [dataAccessLeadTemplate, setDataAccessLeadTemplate] = useState<AccessLeadTemplate | null>(null)
  const [isLoadingAccessLeadTemplate, setIsLoadingAccessLeadTemplate] = useState<boolean>(false)

  const intl = useIntl()
  let dataSuccess: any[] = []
  let dataError: any[] = []
  let dataErrorProduct: any[] = []
  const location = window.location.href

  const { handleChangePipeline, handleInsertPipeline } = useHandleImportPipeline({
    setListData, setListDataProduct, customFields, templatePipelineId: templatePipelineId ?? "", dataUsers, dataLabel: masterLabels, dataMerchants: simpleMerchants, dataProgress: dataAccessLeadTemplate?.leadProgresses, dataProducts: dataAccessLeadTemplate?.leadProducts, dataSources: dataAccessLeadTemplate?.leadSources, dataError, dataSuccess, selectMultiPipeline
  })

  const { handleChangeMerchant, handleBulkInsertMerchant } = useHandleImportMerchant({
    customFields, setListData, templateMerchantId: templateMerchantId ?? "", dataUsers, dataCities, selectMultiMerchant, dataSuccess, dataError, dataLabel: masterLabels
  })

  const { handleChangeUser, handleInsertUser, handleUpdateUser } = useHandleImportUser({
    customFields, setListData, dataLeaders, dataCities, dataRoles, dataAttendanceTemplates, dataSuccess, dataError
  })

  const { handleChangeProduct, handleInsertProduct, handleUpdateProduct } = useHandleImportProduct({
    setListData, dataLabels, dataUnits, dataPriceVariants, dataSuccess
  })

  const filteredCustomFieldUser = getCustomFieldFilteredUser(customFields)

  const filteredCustomFieldMerchant = getCustomFieldFilteredMerchant(templateMerchantId as string, multiMerchants, user!)

  const filteredCustomFieldPipeline = getCustomFieldFilteredPipeline(templatePipelineId as string, multiPipelines, user!)

  const renderButton = (props: any, ref: any, displayMode: string) => {
    return (
      <button
        {...props}
        ref={ref}
        type='button'
        className={`btn btn-light-success ${displayMode === 'card' ? 'btn-sm' : ' mt-3'}`}
      >
        <i className='fas fa-file-download fs-2 me-2'></i>{' '}
        {intl.formatMessage({ id: 'FORM.LABEL.IMPORT_EXCEL' })}
      </button>
    )
  }

  // GET DATA FORM API
  const getUserURL = () => {
    if (user.data.permission_pipeline_read === "ALL" && settings.is_superadmin_allowed_as_pic) {
      return `${API_URL}user/company`
    } else if (user.data.permission_pipeline_read === "ALL") {
      return `${API_URL}users`
    } else {
      return `${API_URL}user/subordinates`
    }
  }

  const getUser = async () => {
    try {
      const response = await getUsers(token, getUserURL())
      if (response.data.success) {
        var data = response.data.data

        if (user.data.permission_merchant_create !== 'NONE') {
          data.unshift({ id: user.data.id, name: user.data.name })
        }

        data.sort((a: any, b: any) => a.name.localeCompare(b.name))
        if (
          user.data.permission_merchant_create === 'ALL' ||
          user.data.permission_merchant_create === 'TEAM'
        ) {
          setDataUsers(data)
        } else {
          setDataUsers(data.filter((item: any) => item.id === user.data.id))
        }
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }

  const getCity = async () => {
    try {
      const response = await getCities(token)
      if (response.data.success) {
        var data = response.data.data

        data.sort((a: any, b: any) => a.name.localeCompare(b.name))
        setDataCities(data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }

  const getRole = async () => {
    try {
      const response = await getRoles(token)
      if (response.data.success) {
        let data = response.data.data

        data.sort((a: any, b: any) => a.name.localeCompare(b.name))
        setDataRoles(data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }

  const getLeader = async () => {
    try {
      const response = await getLeaders(token)
      if (response.data.success) {
        var data = response.data.data

        data.sort((a: any, b: any) => a.name.localeCompare(b.name))
        setDataLeaders(data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }

  const getAttendanceTemplate = async () => {
    try {
      const response = await getAttendanceTemplates(token)
      if (response.data.success) {
        var data = response.data.data

        data.sort((a: any, b: any) => a.name.localeCompare(b.name))
        setDataAttendanceTemplates(data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    }
  }

  const getAccessLeadTemplate = async () => {
    setIsLoadingAccessLeadTemplate(true)
    try {
      if (templatePipelineId) {
        const response = await getLeadTemplateSetting(templatePipelineId, token)
        const responseProduct = await getAccessProductPipeline(templatePipelineId, token)

        if (response.data.success && responseProduct.data.success) {
          setDataAccessLeadTemplate({
            ...response.data.data,
            leadProducts: responseProduct.data.data.sort((a: any, b: any) => a.name.localeCompare(b.name)),
            leadProgresses: response.data.data.leadProgresses.sort((a: any, b: any) => a.name.localeCompare(b.name)),
            leadSources: response.data.data.leadSources.sort((a: any, b: any) => a.name.localeCompare(b.name)),
          })
        }
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error?.response?.data?.message || error?.message || 'Terjadi kesalahan saat mengambil data',
        confirmButtonText: 'Ok'
      })
    } finally {
      setIsLoadingAccessLeadTemplate(false)
    }
  }

  const getLabels = async () => {
    setIsLoadingLabel(true)
    try {
      const response = await getLabel(token)
      if (response.data.success) {
        let data = response.data.data

        data.sort((a: any, b: any) => a.name.localeCompare(b.name));
        setDataLabels(data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok'
      })
    } finally {
      setIsLoadingLabel(false)
    }
  }

  const getUnits = async () => {
    setIsLoadingUnit(true)
    try {
      const response = await getUnit(token)
      if (response.data.success) {
        let data = response.data.data

        data.sort((a: any, b: any) => a.name.localeCompare(b.name));
        setDataUnits(data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok'
      })
    } finally {
      setIsLoadingUnit(false)
    }
  }

  const getPriceVariants = async () => {
    setIsLoadingPriceVariant(true)
    try {
      const response = await getPriceVariant(token)
      if (response.data.success) {
        let data = response.data.data

        data.sort((a: any, b: any) => a.variantPriceName.localeCompare(b.variantPriceName));
        setDataPriceVariants(data)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok'
      })
    } finally {
      setIsLoadingPriceVariant(false)
    }
  }

  // FORM IMPORT EXCEL
  const formik = useFormik({
    initialValues: {
      data: '',
    },
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);

      if (source === 'template-pipeline' || source === 'template-merchant') {
        try {
          await handleCheckExcelNew(listData, listDataProduct, 200, source);
        } catch (error: any) {
          if (error.response.data) {
            dataError = listData.map((data: any) => ({
              ...data,
              error: error.response.data.message,
            }));
          } else {
            dataError = listData.map((data: any) => ({
              ...data,
              error: error.message,
            }));
          }
        }
      } else {
        for (var i = 0; i < listData.length; i++) {
          try {
            setIndexUpload(i);
            await handleCheckExcel(listData[i]);
          } catch (error: any) {
            if (error.response.data) {
              let mergeError = {
                ...listData[i],
                error: error.response.data.message,
              };
              dataError.push(mergeError);
            } else {
              let mergeError = { ...listData[i], error: error.message };
              dataError.push(mergeError);
            }
          }
        }
        if (source === 'template-product') {
          mutate(`${API_URL}products`)
        }
      }

      if (typeAction === 'insert') {
        setListErrorInsert(dataError)
        setListErrorInsertProduct(dataErrorProduct)
      }
      else if (typeAction === 'update') setListErrorUpdate(dataError)
      setListData([])
      setSubmitting(false);

      if (source === 'template-merchant') setTablesData('merchants', ([...dataSuccess, ...tablesData.merchants]));
      else if (source === 'template-user') {
        mutate(`${API_URL}users`)
      }
      else if (source === 'template-unit') {
        if (typeAction === 'insert') {
          let slicedData = [...tablesData.units].slice(0, -1) // remove PCS (default) data
          setTablesData('units', ([...slicedData, ...dataSuccess, {
            name: "PIECES",
            alias: "PCS"
          }]))
        }
        else if (typeAction === 'update') {
          setTablesData('units', (tablesData.units.map(item => {
            var dataSame = dataSuccess.find((data) => data.id === item.id)

            if (dataSame) {
              return {
                ...item,
                name: dataSame.name,
                alias: dataSame.alias,
                color: dataSame.color,
              }
            } else {
              return item
            }
          })));
        }
      }
      else if (source === 'template-product') {
        if (typeAction === 'insert') setTablesData('products', ([...tablesData.products, ...dataSuccess]))
        else if (typeAction === 'update') {
          setTablesData('products', (tablesData.products.map(item => {
            var dataSame = dataSuccess.find((data) => data.id === item.id)

            if (dataSame) {
              return {
                ...item,
                name: dataSame.name,
                // price: dataSame.price,
                prices: dataSame.prices,
                vatPercentage: dataSame.vatPercentage,
                color: dataSame.color,
                productLabels: dataSame.productLabels,
                productUnits: dataSame.productUnits,
                sku: dataSame.sku,
                note: dataSame.note
              }
            } else {
              return item
            }
          })));
        }
      }
      if (dataSuccess.length > 0) {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({ id: 'ALERT.TITLE.SUCCESS' }),
          html: `<b style="color: green;">${dataSuccess.length} Data</b> ${typeAction === 'insert'
            ? intl.formatMessage({ id: 'FORM.VALIDATION.ADD_SUCCESS' })
            : intl.formatMessage({ id: 'FORM.VALIDATION.UPDATE_SUCCESS' })
            }.
                <br>
                ${dataError.length > 0
              ? `<b style="color: red;">${dataError.length} Data </b>${typeAction === 'insert'
                ? intl.formatMessage({ id: 'FORM.VALIDATION.ADD_FAILED' })
                : intl.formatMessage({ id: 'FORM.VALIDATION.UPDATE_FAILED' })
              }`
              : ''
            }
                `,
          heightAuto: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: intl.formatMessage({ id: 'ALERT.TITLE.ERROR' }),
          html: `<b style="color: red;">${dataError.length} Data</b> ${typeAction === 'insert' ? intl.formatMessage({ id: 'FORM.VALIDATION.ADD_FAILED' }) : intl.formatMessage({ id: 'FORM.VALIDATION.UPDATE_FAILED' })}.`,
          heightAuto: false,
        });
      }

      if (source === 'template-pipeline') {
        // mutate(`${API_URL}v2/leads`)
        setFetchCounter(fetchCounter + 1)
      } else if (source === 'template-merchant') {
        mutate(`${API_URL}merchants${templateMerchantId ? `?merchantTemplateId=${templateMerchantId}` : ""}`)
      }

      if (dataError.length === 0) {
        closeModalRef.current?.click();
      }
    }
  });

  useEffect(() => {
    // Get the modal element
    const modalElement = modalRef.current

    // Define the event listeners
    const handleModalHidden = () => {
      formik.resetForm()
      setListData([])
      dataError = []
      dataErrorProduct = []
      dataSuccess = []
    }

    // Attach the event listeners
    modalElement?.addEventListener('hidden.bs.modal', handleModalHidden)

    // Cleanup
    return () => {
      modalElement?.removeEventListener('hidden.bs.modal', handleModalHidden)
    }
  }, [formik])

  const handleCheckExcel = async (data: any) => {
    const customFieldErrors: string[] = []
    if (source === 'template-user') {
      if (typeAction === 'insert') {
        if (!data.username)
          customFieldErrors.push(
            intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'Username' })
          )
        // if (!checkUsername(data.username)) {
        //   customFieldErrors.push(intl.formatMessage({ id: 'ALERT.TEXT.ERROR.USERNAME' }))
        // }
        if (!settings.custom_username_prefix && data.username && !data.username.startsWith(user.data.company_prefix + '-'))
          customFieldErrors.push(`Username harus dimulai dengan ${user.data.company_prefix}-`)
        if (data.email) {
          if (!isEmail(data.email)) {
            customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.EMAIL' }));
          }
        }
        if (!data.phone)
          customFieldErrors.push(
            intl.formatMessage(
              { id: 'FORM.VALIDATION.FIELD_REQUIRED' },
              { title: intl.formatMessage({ id: 'FORM.LABEL.PHONE' }) }
            )
          )
        if (!data.password)
          customFieldErrors.push(
            intl.formatMessage(
              { id: 'FORM.VALIDATION.FIELD_REQUIRED' },
              { title: intl.formatMessage({ id: 'FORM.LABEL.PASSWORD' }) }
            )
          )
        Object.keys(filteredCustomFieldUser).forEach((key) => {
          getCustomFieldError(data, filteredCustomFieldUser, key, customFieldErrors, intl, simplePipelines, simpleMeetings, simpleMerchants, simpleProducts, users, user);
        });
      } else if (typeAction === 'update') {
        if (!data.name)
          customFieldErrors.push(
            intl.formatMessage(
              { id: 'FORM.VALIDATION.FIELD_REQUIRED' },
              { title: intl.formatMessage({ id: 'FORM.LABEL.NAME' }) }
            )
          )
        if (!data.city_id)
          customFieldErrors.push(
            intl.formatMessage(
              { id: 'FORM.VALIDATION.FIELD_REQUIRED' },
              { title: intl.formatMessage({ id: 'FORM.LABEL.CITY' }) }
            )
          )
        if (!data.role_id)
          customFieldErrors.push(
            intl.formatMessage(
              { id: 'FORM.VALIDATION.FIELD_REQUIRED' },
              { title: intl.formatMessage({ id: 'FORM.LABEL.ROLE' }) }
            )
          )
        Object.keys(filteredCustomFieldUser).forEach((key) => {
          getCustomFieldError(data, filteredCustomFieldUser, key, customFieldErrors, intl, simplePipelines, simpleMeetings, simpleMerchants, simpleProducts, users, user);
        })
      }
    } else if (source === 'template-unit') {
      if (!data.name) customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.NAME' }) }));
      if (!data.alias) customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'Alias' }));
    } else if (source === 'template-product') {
      if (!data.name) customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.NAME' }) }));
      if (data.listLeadTemplateAccess) {
        validationListLeadTemplateAccess(data.listLeadTemplateAccess, multiPipelines, customFieldErrors, intl, settings.pipeline_title);
      }
      if (!data.prices) customFieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PRICE' }) }));
      data.prices = data.prices.map((price: any) => {
        if (price.price === undefined || price.price === null || price.price === '' || price.price === 0) {
          return price
        }
        if (isNaN(Number(price.price)) || Number(price.price) < 0) {
          customFieldErrors.push(intl.formatMessage({ id: 'FORM.LABEL.FORMAT_INVALID' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PRICE' }) + ` ${multiCurrencies.find(x => x.id === price.currencyId)?.code}` }));
        }
        return price
      })
    }

    if (customFieldErrors.length === 0) {
      // Masukkan ke newData hanya jika tidak ada kesalahan
      if (source === 'template-user' && typeAction === 'insert') await handleInsertUser(data);
      else if (source === 'template-user' && typeAction === 'update') await handleUpdateUser(data);
      else if (source === 'template-unit' && typeAction === 'insert') await handleInsertUnit(data);
      else if (source === 'template-unit' && typeAction === 'update') await handleUpdateUnit(data);
      else if (source === 'template-product' && typeAction === 'insert') await handleInsertProduct(data);
      else if (source === 'template-product' && typeAction === 'update') await handleUpdateProduct(data);
    } else {
      // Jika ada custom field yang gagal, tambahkan ke dalam array error
      dataError.push({
        ...data,
        error: customFieldErrors.join(", ")
      });

      return customFieldErrors.join(", ")
    }
  }

  const handleCheckExcelNew = async (data: any[], dataProduct: any[], batchSize: number = 200, source: 'template-merchant' | 'template-pipeline') => {
    const validData: any[] = [];
    const invalidData: any[] = [];
    if (source === 'template-pipeline') {
      for (const item of data) {
        const fieldErrors: string[] = [];
        const normalizeDateStart = normalizeDate(item.date_start)
        const normalizeDateEnd = normalizeDate(item.date_end)
        if (!item.date_start) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.VALIDATION.TITLE_DATE_START' }) }));
        }
        if (!moment(normalizeDateStart, 'YYYY-MM-DD', true).isValid()) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.DATE_FORMAT_DYNAMIC' }, { title: intl.formatMessage({ id: 'FORM.VALIDATION.TITLE_DATE_START' }) }));
        }
        if ((normalizeDateEnd < normalizeDateStart) && normalizeDateEnd) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.DATE_END_AFTER_START' }));
        }

        if (item.progress_type === "SUCCESS" || item.progress_type === 'FAIL') {
          if (!normalizeDateEnd || !item.date_end) {
            fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.DATE_FORMAT_PIPELINE' }, { title: intl.formatMessage({ id: 'FORM.VALIDATION.TITLE_DATE_END' }) })) // pengecekan jika date_end tidak ada padahal type 'SUCCESS'
          } else if (!moment(normalizeDateEnd, 'YYYY-MM-DD', true).isValid()) {
            fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.DATE_FORMAT_DYNAMIC' }, { title: intl.formatMessage({ id: 'FORM.VALIDATION.TITLE_DATE_END' }) }));
          }
        } else {
          if (item.date_end && item.date_end.trim() !== '') {
            if (!moment(normalizeDateEnd, 'YYYY-MM-DD', true).isValid()) {
              fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.DATE_FORMAT_DYNAMIC' }, { title: intl.formatMessage({ id: 'FORM.VALIDATION.TITLE_DATE_END' }) }));
            }
          }
        }
        if (!item.source_id) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'Source' }));
        }
        if (!item.merchant_id) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'Merchant' }));
        }
        if (!item.pic_id) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'PIC' }));
        }

        if (item.products.length === 0) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: '(Form Produk) Product' }));
        }

        if (item.products.length > 0) { // mengecek juga untuk sheet1 di karenakan kemungkinan terdapat row yang tidak ada product
          item.products.forEach((product: any) => {
            if (!product.id || !product.name) {
              fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: '(Form Produk) Product' }));
            }
            // if (!product.qty) {
            //   fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: '(Form Produk) Qty' }));
            // }
            // if (!product.price) {
            //   fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: '(Form Produk) Price' }));
            // }
            // if (product.total && product.total < 0) {
            //   fieldErrors.push('(Form Produk) ' + intl.formatMessage({ id: 'FORM.VALIDATION.TOTAL_NOT_BE_NEGATIVE' }));
            // }
          });
        }

        if (item.label_name) {
          fieldErrors.push(...validateLabel(item, masterLabels ?? [], intl));
        }

        Object.keys(filteredCustomFieldPipeline).forEach((key, index) => {
          getCustomFieldError(item, filteredCustomFieldPipeline, key, fieldErrors, intl, simplePipelines, simpleMeetings, simpleMerchants, simpleProducts, users, user);
        });

        if (fieldErrors.length > 0) {
          invalidData.push({
            ...item,
            error: fieldErrors.join(", ")
          });
        } else {
          validData.push(item);
        }
      }

      for (const item of dataProduct) {
        const fieldErrorsProduct: string[] = [];
        if (!item.pipeline) {
          fieldErrorsProduct.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'Pipeline' }));
        }
        if (!item.id || !item.name) {
          fieldErrorsProduct.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'Product' }));
        }
        // if (!item.qty) {
        //   fieldErrorsProduct.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'Qty' }));
        // }
        // if (!item.price) {
        //   fieldErrorsProduct.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: 'Price' }));
        // }
        // if (item.total && item.total < 0) {
        //   fieldErrorsProduct.push(intl.formatMessage({ id: 'FORM.VALIDATION.TOTAL_NOT_BE_NEGATIVE' }));
        // }

        dataErrorProduct.push({
          ...item,
          error: fieldErrorsProduct.join(", ")
        });
      }
    } else if (source === 'template-merchant') {
      for (const item of data) {
        const fieldErrors: string[] = [];
        if (!item.pic_id) fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PIC' }) }));
        if (!item.name) fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.NAME' }) }));
        if (!item.city_id) fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.CITY' }) }));
        if (!item.phone) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PHONE' }) }));
        } else if (isNaN(item.phone)) {
          fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.PHONE_NUMBER' }));
        }
        if (item.email) {
          if (!isEmail(item.email)) {
            fieldErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.EMAIL' }));
          }
        }
        if (item.label_name) {
          fieldErrors.push(...validateLabel(item, masterLabels ?? [], intl));
        }

        Object.keys(filteredCustomFieldMerchant).forEach((key) => {
          getCustomFieldError(item, filteredCustomFieldMerchant, key, fieldErrors, intl, simplePipelines, simpleMeetings, simpleMerchants, simpleProducts, users, user);
        });

        if (fieldErrors.length > 0) {
          invalidData.push({
            ...item,
            error: fieldErrors.join(", ")
          });
        } else {
          validData.push(item);
        }
      }
    }


    // Proses data yang valid
    if (validData.length > 0) {
      try {
        if (source === 'template-pipeline') {
          await handleInsertPipeline(validData, batchSize);
        } else if (source === 'template-merchant') {
          await handleBulkInsertMerchant(validData, batchSize);
        }
      } catch (error) {
        console.error('Error processing valid data:', error);
        // Handle error sesuai kebutuhan
      }
    }

    // Tambahkan data yang tidak valid ke dalam dataError
    if (invalidData.length > 0) {
      dataError.push(...invalidData);
    }
  };

  // HANDLE UNIT
  const handleChangeUnit = (e: any) => {
    setListData([]);
    var check_excel = true;
    var empty_excel = false;
    var success = false;
    const file = e;
    const wb = new ExcelJS.Workbook();
    const reader = new FileReader();

    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      const buffer: any = reader.result;
      wb.xlsx.load(buffer).then((workbook: any) => {
        const newData: any = [];
        var nameWorksheet = workbook.getWorksheet("Sheet1")
        var nameWorksheetInfo = workbook.getWorksheet("Info")
        if (nameWorksheetInfo !== undefined) {
          nameWorksheetInfo.eachRow(async (rowInfo: any, rowIndexInfo: number) => {
            if (rowIndexInfo > 3) {
              if (rowInfo.values[2] === `Template Insert Unit` || rowInfo.values[2] === `Template Error Insert Unit`) {
                nameWorksheet?.eachRow((row: any, rowIndex: number) => {
                  if (rowIndex > 2) {
                    const rowData = row.values
                    if (Array.isArray(rowData)) {
                      newData.push({
                        name: rowData[1],
                        alias: rowData[2]
                      })

                      check_excel = true
                      success = true
                      empty_excel = false
                    }
                  } else {
                    empty_excel = true
                    return false
                  }
                });
              } else if (rowInfo.values[2] === `Template Update Unit` || rowInfo.values[2] === `Template Error Update Unit`) {
                nameWorksheet?.eachRow((row: any, rowIndex: number) => {
                  if (rowIndex > 2) {
                    const rowData = row.values
                    if (Array.isArray(rowData)) {
                      var id = atob(rowData[1])

                      newData.push({
                        id: id.slice(0, 3) + id.slice(6),
                        name: rowData[2],
                        alias: rowData[3],
                        color: rowData[5]
                      })

                      check_excel = true
                      success = true
                      empty_excel = false
                    }
                  } else {
                    empty_excel = true
                    return false
                  }
                });
              } else {
                check_excel = false
                return false
              }
            }
          })
        } else {
          check_excel = false
        }

        if (empty_excel) {
          Swal.fire({
            icon: 'error',
            title: intl.formatMessage({ id: 'FORM.VALIDATION.FILL_DATA_FIRST' }),
            confirmButtonText: 'Ok'
          });
        }

        if (!check_excel) {
          Swal.fire({
            icon: 'error',
            title: intl.formatMessage({ id: 'FORM.VALIDATION.EXCEL_TEMPLATE_NOT_MATCHING' }),
            confirmButtonText: 'Ok'
          });
        }

        if (success) setListData(newData);
      });
    };
  };

  const handleInsertUnit = async (data: any) => {
    const response = await insertUnit(data.name, data.alias, randomColor(), token)

    if (response.data.success) {
      dataSuccess.push(response.data.data)
    } else {
      // var mergeError = { ...data, error: response.data.message }
      // dataError.push(mergeError)
    }
  }

  const handleUpdateUnit = async (data: any) => {
    const response = await updateUnit(data.id, data.name, data.alias, data.color, token)

    if (response.data.success) {
      dataSuccess.push(response.data.data)
    } else {
      // var mergeError = { ...data, error: response.data.message }
      // dataError.push(mergeError)
    }
  }
  useEffect(() => {
    if (source === 'template-merchant') {
      getUser()
      getCity()
    } else if (source === 'template-user') {
      getCity()
      getRole()
      getLeader()
      getAttendanceTemplate()
    } else if (source === 'template-pipeline') {
      getUser()
      getAccessLeadTemplate()
    } else if (source === 'template-product') {
      getLabels()
      getUnits()
      getPriceVariants()
    }
  }, [templatePipelineId, source])

  useEffect(() => {
    if (source === 'template-merchant' && templateMerchantId && multiMerchants.length > 0) {
      var data = multiMerchants.find(item => item.id === templateMerchantId)?.customFields ?? {}
      setCustomFields(data)
    } else if (source === 'template-user' && settings.users_custom_fields) {
      setCustomFields(JSON.parse(settings.users_custom_fields))
    } else if (source === 'template-pipeline' && templatePipelineId && multiPipelines.length > 0) {
      var data = multiPipelines.find(item => item.id === templatePipelineId)?.customFields ?? {}
      setCustomFields(data)
    }
  }, [settings, source, multiPipelines, multiMerchants, location])

  useEffect(() => {
    return () => {

      setIsOpenModalSelectCustomField(false);
      setIsCustomFieldPipeline(false);
      setIsCustomFieldMerchant(false);
      setIsCustomFieldUser(false);
      setIsCustomFieldMeeting(false);
    };
  }, []);

  return (
    <>
      {
        source === 'template-user' || source === 'template-unit' || source === 'template-product' || source === 'template-merchant' ?
          <Dropdown renderToggle={(props, ref) => renderButton(props, ref, displayMode!)} noCaret placement="bottomEnd">
            <Dropdown.Item data-bs-toggle="modal" data-bs-target={`#import-excel-${source}-modal`} onClick={() => setTypeAction("insert")}>{intl.formatMessage({ id: 'FORM.ACTION.ENTER_DATA' })}</Dropdown.Item>
            <Dropdown.Item data-bs-toggle="modal" data-bs-target={`#import-excel-${source}-modal`} onClick={() => setTypeAction("update")}>{intl.formatMessage({ id: 'FORM.ACTION.UPDATE_DATA' })}</Dropdown.Item>
          </Dropdown>
          :
          <button
            type="button"
            className={`btn btn-light-success ${displayMode === "card" ? "btn-sm" : " mt-3"}`}
            data-bs-toggle="modal"
            data-bs-target={`#import-excel-${source}-modal`}
            onClick={() => setTypeAction("insert")}
          >
            <i className="fas fa-file-download fs-2 me-2"></i> {intl.formatMessage({ id: 'FORM.LABEL.IMPORT_EXCEL' })}
          </button>
      }


      <div className="modal fade" tabIndex={-1} id={`import-excel-${source}-modal`} ref={modalRef} >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{intl.formatMessage({ id: 'FORM.LABEL.IMPORT_EXCEL' })}</h5>
              <div
                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <KTSVG
                  path="/media/icons/duotune/arrows/arr061.svg"
                  className="svg-icon svg-icon-2x"
                />
              </div>
            </div>
            {
              (source === 'template-merchant') ||
                (source === 'template-user') ||
                (source === 'template-pipeline' && !isLoadingAccessLeadTemplate) ||
                (source === 'template-unit') ||
                (source === 'template-product' && !isLoadingLabel && !isLoadingUnit && !isLoadingPriceVariant) ?
                <form onSubmit={formik.handleSubmit} noValidate>
                  <div className="modal-body" style={{ height: "300px" }}>
                    <DataTableExportTemplate closeModalRef={closeModalRef} source={source} typeAction={typeAction} user={user} param={{ dataUsers, dataCities, dataRoles, dataLeaders, dataAttendanceTemplates, dataProducts: dataAccessLeadTemplate?.leadProducts ?? [], dataProgress: dataAccessLeadTemplate?.leadProgresses ?? [], dataSources: dataAccessLeadTemplate?.leadSources ?? [], dataLabels, dataUnits, multiPipelines, dataPriceVariants }} customFields={customFields} isOpenModalSelectCustomField={isOpenModalSelectCustomField} />

                    {
                      listErrorInsert.length > 0 && typeAction === 'insert' &&
                      <DataTableExportTemplate closeModalRef={closeModalRef} source={source} typeAction={typeAction} user={user} param={{ dataUsers, dataCities, dataRoles, dataLeaders, dataAttendanceTemplates, dataProducts: dataAccessLeadTemplate?.leadProducts ?? [], dataProgress: dataAccessLeadTemplate?.leadProgresses ?? [], dataSources: dataAccessLeadTemplate?.leadSources ?? [], dataLabels, dataUnits, multiPipelines, dataPriceVariants, listErrorInsert, listErrorInsertProduct }} type="error" customFields={customFields} isOpenModalSelectCustomField={isOpenModalSelectCustomField} />
                    }

                    {
                      listErrorUpdate.length > 0 && typeAction === 'update' &&
                      <DataTableExportTemplate closeModalRef={closeModalRef} source={source} typeAction={typeAction} user={user} param={{ dataUsers, dataCities, dataRoles, dataLeaders, dataAttendanceTemplates, dataProducts: dataAccessLeadTemplate?.leadProducts ?? [], dataProgress: dataAccessLeadTemplate?.leadProgresses ?? [], dataSources: dataAccessLeadTemplate?.leadSources ?? [], dataLabels, dataUnits, multiPipelines, dataPriceVariants, listErrorUpdate }} type="error" customFields={customFields} isOpenModalSelectCustomField={isOpenModalSelectCustomField} />
                    }

                    <FileUploader
                      fileOrFiles={listData.length === 0 ? null : listData}
                      classes="h-50"
                      handleChange={
                        source === 'template-merchant'
                          ? handleChangeMerchant
                          : source === 'template-pipeline'
                            ? handleChangePipeline
                            : source === 'template-unit'
                              ? handleChangeUnit
                              : source === 'template-product'
                                ? handleChangeProduct
                                : handleChangeUser
                      }
                      name="file"
                      types={["XLSX", "XLS", "CSV"]}
                    />

                    {
                      listData.length > 0 &&
                      <div style={{ padding: "10px" }}>{customThousandSeparatorDot(listData.length)} {intl.formatMessage({ id: 'FORM.LABEL.DATA_UPLOAD' })}</div>
                    }
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-light"
                      data-bs-dismiss="modal"
                      ref={closeModalRef}
                    >
                      {intl.formatMessage({ id: 'FORM.ACTION.CANCEL' })}
                    </button>
                    <button type="submit" className={`btn btn-primary me-10 ${formik.isSubmitting ? "disabled" : ""}`} data-kt-indicator={formik.isSubmitting ? 'on' : 'off'}>
                      <span className="indicator-label">
                        {intl.formatMessage({ id: 'FORM.ACTION.UPLOAD' })}
                      </span>
                      {source !== 'template-pipeline' && source !== 'template-merchant' ? (
                        <span className="indicator-progress">
                          Loading... &nbsp;
                          {indexUpload + " / " + customThousandSeparatorDot(listData.length)}
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <span className="indicator-progress">
                          Loading... &nbsp;
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </div>
                </form>
                :
                <div className="modal-body" style={{ height: "200px" }}>
                  <div className="loading-overlay">
                    <div className="loader"></div>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
      {
        isOpenModalSelectCustomField && <ModalSelectDataCustomField customFields={customFields} source={source} typeAction={typeAction} param={{ dataUsers, dataCities, dataRoles, dataLeaders, dataAttendanceTemplates, dataProducts: dataAccessLeadTemplate?.leadProducts ?? [], dataProgress: dataAccessLeadTemplate?.leadProgresses ?? [], dataSources: dataAccessLeadTemplate?.leadSources ?? [], dataLabels, dataUnits }} type={'success'} labels={masterLabels} />
      }
    </>
  )
}

export { DataTableImport }
